import React from 'react'
import UserList from '../../../containers/UserList'

const UserListPage = () => {
    return (
        <div>
            <UserList />
        </div>
    )
}

export default UserListPage
